import {types} from 'mobx-state-tree';

const VolumeUnitModel = types
    .model('VolumeUnitModel', {
      key: types.string,
      name: types.string,
      fullName: types.string,
      factor: types.number,
    });

export default VolumeUnitModel;

